import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ApiService from 'redux/services/api-service';

export interface LocationConfigurationPreset {
  id: number;
  name: string;
  geo_type: 'area' | 'state';
}

interface IState {
  presets: LocationConfigurationPreset[];
  loading: boolean;
  applyInProgress: boolean;
}

export const locationConfigurationPresetEndpoints = {
  listPresets: createAsyncThunk(
    'locationConfigurationPreset/listPresets',
    async (params: {geo_type?: string; search?: string} = {}) => {
      const queryParams: Record<string, string> = {};
      if (params.geo_type) queryParams.geo_type = params.geo_type;
      if (params.search) queryParams.search = params.search;
      const response = await ApiService.get(
        `/location_configuration_preset/?${new URLSearchParams(queryParams).toString()}`,
      );
      return response.data;
    },
  ),
  applyPreset: createAsyncThunk(
    'locationConfigurationPreset/applyPreset',
    async ({
      presetId,
      campaign_id,
      missing_test_control_eligibility,
    }: {
      presetId: number;
      campaign_id: number;
      missing_test_control_eligibility?: string | null;
    }) => {
      const response = await ApiService.post(`/location_configuration_preset/${presetId}/apply_preset/`, {
        campaign_id,
        missing_test_control_eligibility,
      });
      return response.data;
    },
  ),
};

export const locationConfigurationPresetSlice = createSlice({
  name: 'locationConfigurationPreset',
  initialState: {
    presets: [],
    loading: false,
    applyInProgress: false,
  } as IState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(locationConfigurationPresetEndpoints.listPresets.pending, state => {
        state.loading = true;
      })
      .addCase(locationConfigurationPresetEndpoints.listPresets.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.presets = payload.results ?? payload;
      })
      .addCase(locationConfigurationPresetEndpoints.listPresets.rejected, state => {
        state.loading = false;
      })
      .addCase(locationConfigurationPresetEndpoints.applyPreset.pending, state => {
        state.applyInProgress = true;
      })
      .addCase(locationConfigurationPresetEndpoints.applyPreset.fulfilled, state => {
        state.applyInProgress = false;
      })
      .addCase(locationConfigurationPresetEndpoints.applyPreset.rejected, state => {
        state.applyInProgress = false;
      });
  },
});

export type LocationConfigurationPresetSlice = {
  [locationConfigurationPresetSlice.name]: ReturnType<(typeof locationConfigurationPresetSlice)['reducer']>;
};
